"use strict";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  DefaultBuyerName: () => DefaultBuyerName,
  login: () => login,
  useAuth: () => useAuth,
  useAuthStore: () => useAuthStore
});
module.exports = __toCommonJS(src_exports);

// src/useAuthStore.ts
var import_zustand = require("zustand");
var import_middleware = require("zustand/middleware");

// src/buyerNames.ts
var DefaultBuyerName = null;

// src/useAuthStore.ts
var initialUser = {
  id: null,
  name: DefaultBuyerName,
  email: null,
  nationalId: null,
  role: "BUYER"
};
var useAuthStore = (0, import_zustand.create)()(
  (0, import_middleware.persist)(
    (set) => ({
      user: __spreadValues({}, initialUser),
      eventId: null,
      setCreds: (newUser) => set((state) => ({
        user: __spreadValues(__spreadValues({}, state.user), newUser)
      })),
      setUsername: (username) => set((state) => ({
        user: __spreadProps(__spreadValues({}, state.user), {
          name: username
        })
      })),
      setEmail: (email) => set((state) => ({
        user: __spreadProps(__spreadValues({}, state.user), {
          email
        })
      })),
      setNationalId: (nationalId) => set((state) => ({
        user: __spreadProps(__spreadValues({}, state.user), {
          nationalId
        })
      })),
      setEventId: (eventId) => set(() => ({
        eventId
      })),
      clearAuth: () => set(() => ({
        user: __spreadValues({}, initialUser),
        eventId: null
      }))
    }),
    {
      name: "auth",
      storage: {
        getItem: (name) => {
          const item = localStorage.getItem(name);
          return item ? JSON.parse(item) : null;
        },
        setItem: (name, value) => localStorage.setItem(name, JSON.stringify(value)),
        removeItem: (name) => localStorage.removeItem(name)
      },
      partialize: (state) => ({
        user: {
          id: state.user.id,
          name: state.user.name,
          email: state.user.email,
          nationalId: state.user.nationalId,
          role: state.user.role
        },
        eventId: state.eventId,
        setCreds: state.setCreds,
        setUsername: state.setUsername,
        setEmail: state.setEmail,
        setNationalId: state.setNationalId,
        setEventId: state.setEventId,
        clearAuth: state.clearAuth
      })
    }
  )
);

// src/useAuth.ts
var useAuth = () => {
  const state = useAuthStore((currentState) => currentState);
  return __spreadValues({}, state);
};

// src/authService.ts
var import_uuid = require("uuid");
var login = () => __async(void 0, null, function* () {
  const currentId = useAuthStore.getState().user.id;
  useAuthStore.getState().setCreds({
    id: currentId || (0, import_uuid.v4)()
  });
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  DefaultBuyerName,
  login,
  useAuth,
  useAuthStore
});
